import { StyleRules } from '@material-ui/core/styles';
import { FormControlLabelClassKey } from '@material-ui/core/FormControlLabel';

import { core as theme } from '../styles/core';

export const MuiFormControlLabel: Partial<StyleRules<
  FormControlLabelClassKey
>> = {
  label: {
    color: theme.palette.text.primary,
    '&.Mui-disabled': {
      color: theme.palette.grey[300],
    },
    fontSize: theme.typography.button.fontSize,
    fontWeight: theme.typography.button.fontWeight,
  },
};
